/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  Box,
  Grid2,
  Divider,
  IconButton,
  Tooltip,
  FormControlLabel,
  Checkbox,
  OutlinedInput,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { showMeters } from 'js/actions/meterActions';
import { showGroups } from 'js/actions/groupActions';
import { showCharge } from 'js/actions/chargeActions';
import {
  deleteReport,
  getReports,
  sendReports,
  updateReport,
} from 'js/actions/reportsActions';
import moment from 'moment';
import { Delete, Edit } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { useIntl } from 'react-intl';

export default function StepperForm({ open, handleClose }) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { corporatives } = useSelector((state) => state.corporatives);
  const { meters } = useSelector((state) => state.meters);
  const { user } = useSelector((state) => state.user);
  const groups = useSelector((state) => state.groups.groups);
  const charges = useSelector((state) => state.charges.charges);
  const { reports } = useSelector((state) => state.meters);

  const TYPES = {
    HORARIOS: 'Horarios',
    TOTALES: 'Totales',
  };

  const TYPESREPORT = {
    CONSUMO: 'CONSUME',
    DEMAND: 'DEMAND',
  };

  const [activeStep, setActiveStep] = useState(0);
  const [daySelected, setDaySelected] = useState('03');
  const [hourSelected, setHourSelected] = useState('00:00');
  const [corporative, setCorporative] = useState('');
  const [type, setType] = useState(TYPES.HORARIOS);
  const [typeReport, setTypeReport] = useState(TYPESREPORT.CONSUMO);
  const [meter, setMeter] = useState('');
  const [charge, setCharge] = useState([]);
  const [group, setGroup] = useState([]);
  const [contacts, setContacts] = useState([{ name: '', email: '' }]);
  const [editMode, setEditMode] = useState(false);
  const [createMode, setCreateMode] = useState(
    reports === undefined ? true : false
  );
  const [includePrice, setIncludePrice] = useState(false);
  const [editingReportId, setEditingReportId] = useState(null);

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  const handleCheckBox = () => {
    setIncludePrice(!includePrice);
  };

  const steps = [
    'Fecha y Hora',
    'Seleccionar Informacion',
    'Contactos',
    'Confirmación',
  ];

  useEffect(() => {
    if (reports === undefined) {
      setCreateMode(true);
    } else {
      setCreateMode(false);
    }
  }, [reports]);

  useEffect(() => {
    if (user.corporative && user.adser !== 1) {
      dispatch(showMeters(user.corporative.id));
    } else if (corporative) {
      dispatch(showMeters(corporative));
    }
  }, [corporative]);

  useEffect(() => {
    if (reports === undefined) {
      setCreateMode(true);
    } else {
      setCreateMode(false);
    }
  }, [reports]);

  useEffect(() => {
    dispatch(getReports(user.personal_info.id_user));
  }, []);

  useEffect(() => {
    if (meter) {
      dispatch(showGroups(meter));
    }
  }, [meter]);

  useEffect(() => {
    if (group && group.length === 1) {
      dispatch(showCharge(group[0].id));
    } else {
      setCharge(['TODAS']);
    }
  }, [group]);

  const handleNext = () => setActiveStep((prevStep) => prevStep + 1);
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  const handleContactChange = (index, field, value) => {
    const newContacts = [...contacts];
    newContacts[index][field] = value;
    setContacts(newContacts);
  };

  const handleAddContact = () => {
    setContacts([...contacts, { name: '', email: '' }]);
  };

  const handleGroupChange = (event) => {
    const selectedIds = event.target.value;

    const selectedGroups = groups
      .filter((g) => selectedIds.includes(g.id))
      .map((g) => ({ id: g.id, name: g.name }));

    setGroup(selectedGroups);

    if (selectedGroups.length > 1) {
      setCharge(['TODAS']);
    } else {
      setCharge([]);
    }
  };

  const reportData = {
    type: type,
    alert_date: daySelected,
    alert_time: hourSelected,
    data: {
      corporative,
      meter,
      groups: group,
      charges: charge,
      type: typeReport,
      cost: includePrice ? 1 : 0,
    },
    contacts,
    user_id: user.personal_info.id_user,
    ...(editMode && { id: editingReportId }), // Solo se agrega en modo edición
  };

  const handleSubmit = () => {
    dispatch(sendReports(reportData));
    dispatch(getReports(user.personal_info.id_user));
    setContacts([{ name: '', email: '' }]);
    setDaySelected(0);
    setHourSelected('00:00');
    setCorporative('');
    setMeter('');
    setGroup([]);
    setCharge([]);
    setActiveStep(0);
    setEditMode(false);
    setCreateMode(false);
    dispatch(getReports(user.personal_info.id_user));
  };

  const handleEdit = (report) => {
    setDaySelected(report.alert_date);
    setHourSelected(report.alert_time);
    setCorporative(report.data.corporative);
    setType(report.type);
    setTypeReport(report.data.type);
    setIncludePrice(report.data.cost === 1);
    setMeter(report.data.meter);
    setGroup(report.data.groups);
    setCharge(report.data.charges);
    setContacts(report.contacts);

    setEditMode(true);
    setCreateMode(false);
    setEditingReportId(report._id);
  };

  const handleSave = () => {
    dispatch(updateReport(reportData));
    dispatch(getReports(user.personal_info.id_user));
    setDaySelected('03');
    setHourSelected('00:00');
    setCorporative('');
    setType(TYPES.HORARIOS);
    setTypeReport(TYPESREPORT.CONSUMO);
    setMeter('');
    setGroup([]);
    setCharge([]);
    setContacts([{ name: '', email: '' }]);
    setActiveStep(0);
    setEditMode(false);
    setCreateMode(false);
    handleClose();
  };

  const handleDelete = async (report) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Eliminando...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      try {
        // Esperar a que deleteReport se complete antes de continuar
        dispatch(deleteReport(report._id));

        // Una vez eliminado, mostrar éxito
        Swal.fire({
          title: 'Eliminado',
          text: 'El reporte ha sido eliminado con éxito.',
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        console.error(error);
        // Si hay error, mostrar alerta
        Swal.fire({
          title: 'Error',
          text: 'Hubo un problema al eliminar el reporte.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    } else {
      Swal.fire({
        title: 'Cancelado',
        text: 'El reporte no fue eliminado.',
        icon: 'info',
        confirmButtonText: 'Aceptar',
      });
    }
    dispatch(getReports(user.personal_info.id_user));
  };

  const disabledSendButton = () => {
    if (activeStep === 0) {
      return !daySelected || !hourSelected;
    } else if (activeStep === 1) {
      return !corporative || !meter || !group;
    } else if (activeStep === 2) {
      return contacts.some((c) => !c.name || !emailRegex.test(c.email));
    }
    return false;
  };

  const disabledNextButton = () => {
    if (activeStep === 0) {
      return !daySelected || !hourSelected;
    } else if (activeStep === 1) {
      return !corporative || !meter || !group;
    } else if (activeStep === 2) {
      return contacts.some((c) => !c.name || !emailRegex.test(c.email));
    }
    return false;
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleCharge = (chargeVal) => {
    const { value } = chargeVal.target;
    setCharge(value); // value será un array de ids seleccionados
    // Si selecciona "TODAS", se seleccionan todos los cargos
    // Si no, se selecciona el cargo seleccionado
    if (value.includes('TODAS')) {
      setCharge(['TODAS']);
    } else if (value.length === 1) {
      setCharge(value);
    } else {
      setCharge(value);
    }

    // Si esta seleccionado "TODAS" y seleccionan otro cargo
    // se deselecciona "TODAS" y selecciona el cargo seleccionado
    if (
      chargeVal.target.value.includes('TODAS') &&
      chargeVal.target.value.length > 1
    ) {
      setCharge(chargeVal.target.value.filter((el) => el !== 'TODAS'));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      sx={{ zIndex: 1000 }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Chip
          label={intl.formatMessage({ id: 'app.reports.scheduleReport.title' })}
          sx={{ bgcolor: '#6A1A5F', color: 'white' }}
        />
      </DialogTitle>
      <DialogContent>
        {reports !== undefined &&
          createMode === false &&
          editMode === false && (
            <>
              <Box my={5} maxHeight="550px" overflow="auto">
                {reports.length > 0 &&
                  reports?.map((report, index) => (
                    <Box
                      key={index}
                      my={2}
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(7, 1fr)',
                        gap: 2,
                        gridTemplateRows: 'auto',
                        gridTemplateAreas: `"divider divider divider divider divider divider divider"
                      "day day day time time time section"
                      "group group group group group group section"
                      "name name name email email email section"`,
                      }}
                    >
                      <Box gridArea="divider">
                        <Divider fullWidth={true} textAlign="left">
                          <Typography variant="h6" textAlign="left">
                            Creado el{' '}
                            {moment(report.created_at).format('DD/MM/YYYY')} a
                            las {moment(report.created_at).format('HH:mm')}{' '}
                            <br />
                            {intl.formatMessage({
                              id: 'app.reports.totReportsByType.title',
                            })}
                            : {report.type}
                          </Typography>
                        </Divider>
                      </Box>
                      <Box gridArea="day">
                        <TextField
                          disabled
                          id={index}
                          label="Día de Envío"
                          value={report.alert_date}
                          fullWidth={true}
                        />
                      </Box>
                      <Box gridArea="time">
                        <TextField
                          disabled
                          id={index}
                          label="Hora de Envío"
                          value={report.alert_time}
                          fullWidth={true}
                        />
                      </Box>
                      <Box gridArea="group">
                        <TextField
                          disabled
                          id={index}
                          label="Grupo(s)"
                          value={report?.data?.groups?.map((g) => g.name)}
                          fullWidth={true}
                        />
                      </Box>
                      <Box gridArea="name">
                        <TextField
                          disabled
                          id={index}
                          label="Nombre"
                          value={report.contacts.map((g) => g.name)}
                          fullWidth={true}
                        />
                      </Box>
                      <Box gridArea="email">
                        <TextField
                          disabled
                          id={index}
                          label="Correo"
                          value={report.contacts.map((g) => g.email)}
                          fullWidth={true}
                        />
                      </Box>
                      <Box
                        gridArea="section"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-evenly"
                        alignItems="center"
                        gap="10px"
                      >
                        <Tooltip title="Editar" placement="top">
                          <IconButton onClick={() => handleEdit(report)}>
                            <Edit color="secondary" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar" placement="top">
                          <IconButton onClick={() => handleDelete(report)}>
                            <Delete color="error" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                  ))}
              </Box>
              {reports.length > 1 && <Divider fullWidth />}
              {!editMode && !createMode && (
                <Button
                  type="button"
                  onClick={() => {
                    setActiveStep(0);
                    setCreateMode(true);
                  }}
                  sx={{ mt: 2 }}
                  variant="contained"
                  color="secondary"
                  fullWidth={true}
                >
                  {intl.formatMessage({
                    id: 'app.reports.scheduleReport.createNew',
                  })}
                </Button>
              )}
            </>
          )}
        {(createMode === true || editMode === true) && (
          <>
            {editMode && (
              <Typography mb={5} variant="h6" textAlign="center">
                Editando Reporte
              </Typography>
            )}
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            {activeStep === 0 && (
              <Grid2 container={true} spacing={2} my={5}>
                <Grid2 size={12} container={true} spacing={2} mb={2}>
                  <Grid2 size={6}>
                    <FormControl fullWidth={true}>
                      <InputLabel>Día de Envío</InputLabel>
                      <Select
                        value={daySelected}
                        onChange={(e) => setDaySelected(e.target.value)}
                        input={<OutlinedInput label="Día de Envío" />}
                      >
                        {[...Array(26).keys()].map((day) => (
                          <MenuItem
                            key={day + 3}
                            value={day + 3 < 10 ? `0${day + 3}` : `${day + 3}`}
                          >
                            {day + 3}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={6}>
                    <FormControl fullWidth>
                      <InputLabel>Hora de Envío</InputLabel>
                      <Select
                        value={hourSelected}
                        onChange={(e) => setHourSelected(e.target.value)}
                        input={<OutlinedInput label="Hora de Envío" />}
                      >
                        {[...Array(24).keys()].map((h) => (
                          <MenuItem
                            key={h}
                            value={`${h < 10 ? '0' + h : h}:00`}
                          >{`${h < 10 ? '0' + h : h}:00`}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                </Grid2>
                {reports !== undefined && (
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    fullWidth={true}
                    onClick={() => {
                      setCreateMode(false);
                      setEditMode(false);
                    }}
                  >
                    Ver Todos los Reportes Programados
                  </Button>
                )}
              </Grid2>
            )}

            {activeStep === 1 && (
              <Box my={5}>
                <FormControl fullWidth>
                  <InputLabel>Reporte</InputLabel>
                  <Select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    input={<OutlinedInput label="Reporte" />}
                  >
                    <MenuItem
                      value={TYPES.HORARIOS}
                      sx={{ textTransform: 'uppercase' }}
                    >
                      Horarios
                    </MenuItem>
                    <MenuItem
                      value={TYPES.TOTALES}
                      sx={{ textTransform: 'uppercase' }}
                    >
                      Totales
                    </MenuItem>
                  </Select>
                </FormControl>
                {type === TYPES.HORARIOS ? (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Tipo</InputLabel>
                    <Select
                      value={typeReport}
                      onChange={(e) => setTypeReport(e.target.value)}
                      input={<OutlinedInput label="Tipo" />}
                    >
                      <MenuItem
                        value={TYPESREPORT.CONSUMO}
                        sx={{ textTransform: 'uppercase' }}
                      >
                        Consumo
                      </MenuItem>
                      <MenuItem
                        value={TYPESREPORT.DEMAND}
                        sx={{ textTransform: 'uppercase' }}
                      >
                        Demanda
                      </MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includePrice}
                        onChange={handleCheckBox}
                        name="includePrice"
                        selected={includePrice}
                        color="secondary"
                      />
                    }
                    label={intl.formatMessage({
                      id: 'app.reports.totReports.includePrice',
                    })}
                  />
                )}

                {user.adser === 1 && (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Corporativo</InputLabel>
                    <Select
                      value={corporative}
                      onChange={(e) => setCorporative(e.target.value)}
                      input={<OutlinedInput label="Corporativo" />}
                    >
                      {shortCorporatives().map((corp) => (
                        <MenuItem key={corp.id} value={corp.id}>
                          {corp.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Nodo</InputLabel>
                  <Select
                    value={meter}
                    onChange={(e) => setMeter(e.target.value)}
                    input={<OutlinedInput label="Nodo" />}
                  >
                    {meters.map((m) => (
                      <MenuItem key={m.id} value={m.id}>
                        {m.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Grupos</InputLabel>
                  <Select
                    multiple
                    value={
                      group && group.length > 0 ? group.map((g) => g.id) : []
                    } // Cambiado a un array de IDs
                    onChange={handleGroupChange}
                    input={<OutlinedInput label="Grupos" />}
                    renderValue={(selected) => {
                      if (!selected.length) return 'Seleccione grupos';
                      return selected
                        .map(
                          (id) => groups.find((g) => g.id === id)?.name || ''
                        )
                        .join(', ');
                    }}
                  >
                    {groups.map((g) => (
                      <MenuItem key={g.id} value={g.id}>
                        <Checkbox
                          checked={group?.some(
                            (selected) => selected.id === g.id
                          )}
                        />
                        {g.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {group && group.length === 1 && (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Cargas</InputLabel>
                    <Select
                      multiple
                      value={charge} // Ya es un array de IDs
                      onChange={handleCharge}
                      input={<OutlinedInput label="Cargas" />}
                      renderValue={(selected) => {
                        if (!selected.length) return 'Seleccione grupos'; // Texto por defecto si no hay selección
                        return selected
                          .map((value) => {
                            if (value === 'TODAS') return 'TODAS';
                            // Si el valor es 'TODAS', no buscamos en charges
                            // Buscamos el nombre del cargo en charges
                            // y lo devolvemos
                            // Si no se encuentra, devolvemos un string vacío
                            // para evitar errores
                            // al intentar acceder a la propiedad name
                            // de un objeto undefined
                            // o null
                            const chargeName = charges.find(
                              (el) => el.id === value
                            )?.name;
                            return chargeName ? chargeName : '';
                          })
                          .join(', ');
                      }}
                    >
                      <MenuItem
                        value="TODAS"
                        onClick={() =>
                          handleCharge({ target: { value: 'TODAS' } })
                        }
                      >
                        <Checkbox checked={charge.indexOf('TODAS') > -1} />
                        TODAS
                      </MenuItem>
                      {charges?.map((el) => (
                        <MenuItem value={el.id} key={el.id}>
                          <Checkbox checked={charge.indexOf(el.id) > -1} />
                          {el.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            )}

            {activeStep === 2 && (
              <Box my={5}>
                {contacts.length === 0 ? (
                  <Button
                    onClick={handleAddContact}
                    sx={{ mt: 2 }}
                    variant="contained"
                    color="secondary"
                    fullWidth
                  >
                    Agregar Contacto
                  </Button>
                ) : (
                  contacts.map((contact, index) => (
                    <div key={index} style={{ marginBottom: '16px' }}>
                      <TextField
                        label="Nombre"
                        helperText={
                          !contact.name && 'Nombre requerido, ej: Juan Pérez'
                        }
                        value={contact.name}
                        onChange={(e) =>
                          handleContactChange(index, 'name', e.target.value)
                        }
                        fullWidth
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        label="Email"
                        helperText={
                          !emailRegex.test(contact.email) &&
                          'Email inválido, ej: exemplo@exemplo.com ó exemplousuario@gmail.com, etc.'
                        }
                        value={contact.email}
                        onChange={(e) =>
                          handleContactChange(index, 'email', e.target.value)
                        }
                        fullWidth
                        sx={{ mt: 2 }}
                      />
                    </div>
                  ))
                )}
                {contacts.length > 0 && (
                  <Button
                    onClick={handleAddContact}
                    sx={{ mt: 2 }}
                    variant="contained"
                    color="secondary"
                    fullWidth
                  >
                    Agregar Otro Contacto
                  </Button>
                )}
                {contacts.length > 1 && (
                  // Eliminar ultimo contacto
                  <Button
                    onClick={() => {
                      setContacts(contacts.slice(0, -1));
                    }}
                    sx={{ mt: 2 }}
                    variant="outlined"
                    color="error"
                    fullWidth
                  >
                    Eliminar Ultimo Contacto
                  </Button>
                )}
              </Box>
            )}

            {activeStep === 3 && (
              <>
                <Typography sx={{ my: 2 }} align="center">
                  {intl.formatMessage({
                    id: 'app.reports.scheduleReport.viewData',
                  })}
                </Typography>
                <Grid2 container={true} spacing={2}>
                  <Grid2 size={6}>
                    <TextField
                      value={reportData.type}
                      label="Tipo de Reporte"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  {reportData.type === TYPES.HORARIOS ? (
                    <Grid2 size={6}>
                      <TextField
                        value={reportData.data.type}
                        label="Tipo de Reporte"
                        fullWidth={true}
                        disabled
                      />
                    </Grid2>
                  ) : (
                    <Grid2 size={6}>
                      <TextField
                        value={reportData.data.cost === 1 ? 'Sí' : 'No'}
                        label="Incluir Precio"
                        fullWidth={true}
                        disabled
                      />
                    </Grid2>
                  )}
                  <Grid2 size={6}>
                    <TextField
                      value={reportData.alert_date}
                      label="Día de Envío"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  <Grid2 size={6}>
                    <TextField
                      value={reportData.alert_time}
                      label="Hora de Envío"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  {user.adser === 1 && (
                    <Grid2 size={12}>
                      <TextField
                        value={
                          corporatives.find(
                            (c) => c.id === reportData?.data?.corporative
                          )?.name ?? 'No encontrado'
                        }
                        label="Corporativo"
                        fullWidth={true}
                        disabled
                      />
                    </Grid2>
                  )}
                  <Grid2 size={12}>
                    <TextField
                      value={
                        meters.find((m) => m.id === reportData?.data?.meter)
                          ?.name ?? 'No encontrado'
                      }
                      label="Medidor"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      value={reportData.data.groups.map((g) => g.name)}
                      label="Grupos"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  <Grid2 size={6}>
                    <TextField
                      value={reportData.contacts.map((c) => c.name)}
                      label="Nombre"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                  <Grid2 size={6}>
                    <TextField
                      value={reportData.contacts.map((c) => c.email)}
                      label="Email"
                      fullWidth={true}
                      disabled
                    />
                  </Grid2>
                </Grid2>
              </>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={() => {
            handleClose();
            setActiveStep(0);
            setDaySelected(0);
            setHourSelected('00:00');
            setCorporative('');
            setMeter('');
            setGroup([]);
            setCharge([]);
            setContacts([{ name: '', email: '' }]);
            setEditMode(false);
            if (reports === undefined) {
              setCreateMode(true);
            } else {
              setCreateMode(false);
            }
          }}
          color="error"
          variant="outlined"
          fullWidth={true}
        >
          Cerrar
        </Button>

        {(createMode === true || editMode === true) && (
          <>
            {activeStep > 0 && (
              <Button
                onClick={handleBack}
                color="secondary"
                variant="outlined"
                fullWidth={true}
              >
                Atrás
              </Button>
            )}

            {activeStep < steps.length - 1 ? (
              <Button
                onClick={handleNext}
                color="secondary"
                variant="contained"
                fullWidth={true}
                disabled={
                  !editMode && !createMode ? false : disabledNextButton()
                }
              >
                Siguiente
              </Button>
            ) : (
              <Button
                onClick={editMode ? handleSave : handleSubmit}
                variant="contained"
                color="secondary"
                fullWidth={true}
                disabled={
                  !editMode && !createMode ? false : disabledSendButton()
                }
              >
                {editMode ? 'Actualizar' : 'Crear'}
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
